import "../Styles/Employee_sign.css";
import { useNavigate, useLocation } from "react-router-dom";
import { check_email, register_user_by_email } from "../api/serverWrapper";
import UserSystemRole from "../components/UserSystemRole";
import { saveData, getData } from "../utils/store-data";
import {
  LOGIN_BY,
  USER_EMAIL,
  USER_ID,
  GOOGLE_USER,
} from "../utils/store-data-constants";
import { loginByEmail } from "../utils/Constants";

const AccountConfiguration = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { signupEmail, signupPassWord, isEmailSignup } = location.state || {};

  const registerUser = async (systemRole) => {
    try {
      const data = {
        EMail: signupEmail,
        Password: signupPassWord,
        SystemRole: systemRole,
        IsTempRegistered: 1,
        LoginBy: loginByEmail,
      };

      let checkemail = await check_email(signupEmail);
      console.log(checkemail);

      if (!checkemail.success) {
        alert("Email already Registerd Please Login ");
        navigate("/loginpage");
        return
      }

      const res = await register_user_by_email(data);

      if (res.success) {
        await saveData(LOGIN_BY, loginByEmail);
        await saveData(USER_EMAIL, signupEmail);
        await saveData(USER_ID, res.data.UserId);

        if (systemRole === UserSystemRole.AGENT.id) {
          navigate("/business_setup");
        } else {
          navigate("/client-profile-selection");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleJoin = async () => {
    // Email signup flow
    if (signupEmail && signupPassWord) {
      await registerUser(UserSystemRole.CLIENT.id);
      return;
    }

    // Old flow
    navigate("/ClientloginType");
  };

  const handleAgent = async () => {
    // Email signup flow
    if (signupEmail && signupPassWord) {
      await registerUser(UserSystemRole.AGENT.id);
      return;
    }

    // Old flow
    navigate("/employee_sign_in");
  };

  const handleClient = () => {
    navigate("/profilelogin");
  };
  return (
    <div className="employee-wrapper">
      <div className="employee-header">
        <div className="header-left">
          <img
            src={require("../assests/images/agent-login-signup-top-logo.png")}
            alt="Logo"
            className="header-logo"
          />
        </div>
        <div className="header-right">
          <span className="header-signup ">Signup | configuration</span>
          <div className="underline-for-agent"></div>
        </div>
      </div>

      <div className="emp">
        <div className="employee-container">
          <h2>How will you be joining Wedluk?</h2>
          <div
            className="underline-for-agent   mt-0"
            style={{ width: "10%" }}
          ></div>

          <div className="employee-roles">
            <div className="employee-role-card" onClick={() => handleJoin()}>
              <img
                className="employee-icon"
                src={require("../assests/images/indivialclient_icon.png")}
              />
              <div>
                <div className="employee-title">As an Individual client</div>
              </div>
              <div className="employee-desc">Create your profile to start</div>
              <div className="employee-desc">looking for matches</div>
            </div>

            <div className="employee-card" onClick={() => handleClient()}>
              <img
                className="activastion-code-icon"
                src={require("../assests/images/ActivationCodeIcon.png")}
              />
              <div>
                <div className="employee-title">Have an activation code?</div>
              </div>
              <div className="employee-desc">
                Activate our existing profile using{" "}
              </div>
              <div className="employee-desc">Activation code</div>
            </div>
            <div className="employee-card" onClick={() => handleAgent()}>
              <img
                className="employee-icon"
                src={require("../assests/images/agent_icon.png")}
              />
              <div>
                <div className="employee-title">As an Agent</div>
              </div>
              <div className="employee-desc">Manage and Help clients</div>
              <div className="employee-desc">find matches.</div>
            </div>
          </div>
        </div>
      </div>

      <div className="emp_footer_line"></div>
    </div>
  );
};

export default AccountConfiguration;
